module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-46ca2432.png";